import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const OkDmvService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const getRenewalsBySearchCriteria = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/okdmv/search${queryString}`, {
      headers,
    });
  };

  service.getRenewalsBySearchCriteria = getRenewalsBySearchCriteria;

  return service;
})();

export default OkDmvService;
